export function isGoogleProfilePicture(value) {
  if (typeof value !== "string") return false;
  try {
    const { hostname } = new URL(value);
    return (
      hostname === "googleusercontent.com" ||
      hostname.endsWith(".googleusercontent.com")
    );
  } catch {
    return false;
  }
}

export function getProfilePictureSources(
  profile,
  { requireFaceCheck = true } = {},
) {
  const custom = profile?.picture_custom || null;
  const importedAllowed =
    (!requireFaceCheck || profile?.picture_face_ok !== false) &&
    !isGoogleProfilePicture(profile?.picture) &&
    !isGoogleProfilePicture(profile?.picture_cached);
  return {
    custom: isGoogleProfilePicture(custom) ? null : custom,
    cached: importedAllowed ? profile?.picture_cached || null : null,
    legacy: importedAllowed ? profile?.picture || null : null,
  };
}

export function getProfilePicture(profile) {
  const { custom, cached, legacy } = getProfilePictureSources(profile);
  return custom || cached || legacy || null;
}

export function getDisplayPictureFields(profile) {
  const sources = getProfilePictureSources(profile);
  return {
    picture: sources.legacy,
    picture_cached: sources.cached,
    picture_custom: sources.custom,
    picture_face_ok: profile?.picture_face_ok ?? null,
  };
}
